import { render, staticRenderFns } from "./SectionQuestionTest.vue?vue&type=template&id=a2412b40"
import script from "./SectionQuestionTest.vue?vue&type=script&lang=js"
export * from "./SectionQuestionTest.vue?vue&type=script&lang=js"
import style0 from "./SectionQuestionTest.vue?vue&type=style&index=0&id=a2412b40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports